import {Map} from 'immutable';
import _ from 'lodash';
import {ModuleEvents} from './Actions';
//import { ModuleEvents as SigninEvent } from "../signin/Actions";

const InitialState = Map({
  loadingAction: {loading: false, action: {}},
  uploadedVideoList:[],
  popupClose:false,
  resetData: {},
  courseSubtitleList: [],
  languagesList: [],
  regeneratingVideoId: null,
  subtitleStatus: null,
  videoAssociation: null,
});



export const Reducer = (state = InitialState, action) => {
  const {payload, type} = action;
  switch (type) {
   
    case ModuleEvents.FETCH_ALL_VIDEO: {
      if (payload && !payload.error && payload.status_code && payload.status_code == 1) {
        const data = _.get(payload, 'data', {});
        const page = payload?.params?.page || 1;

        if (page > 1) {
          const currentData = state.get('uploadedVideoList');
          const currentList = Array.isArray(currentData)
            ? currentData
            : Array.isArray(currentData?.data)
            ? currentData.data
            : [];
          const newItems = Array.isArray(data)
            ? data
            : Array.isArray(data?.data)
            ? data.data
            : [];

          const existingIds = new Set(currentList.map(item => item.id));
          const uniqueNewItems = newItems.filter(item => !existingIds.has(item.id));
          const combined = [...currentList, ...uniqueNewItems];

          if (!Array.isArray(data) && typeof data === 'object') {
            return state.set('uploadedVideoList', { ...data, data: combined });
          }
          return state.set('uploadedVideoList', combined);
        }

        return state.set('uploadedVideoList', data);
      }
      return state;
    }
    
    case ModuleEvents.UPLOAD_VIDEO: {
      
      return state.set("popupClose",false);
    }

    case ModuleEvents.FETCH_SUBTITLE_LIST: {
      if (payload && !payload.error && payload.status_code && payload.status_code == 1) {
        const data = _.get(payload, 'data', []);
        return state.set('courseSubtitleList', data);
      }
      return state;
    }

    case ModuleEvents.FETCH_LANGUAGES: {
      if (payload && !payload.error && payload.status_code && payload.status_code == 1) {
        const data = _.get(payload, 'data', []);
        return state.set('languagesList', data);
      }
      return state;
    }

    case ModuleEvents.REGENERATE_SUBTITLES: {
      if (payload && !payload.error) {
        const videoId = payload?.params?.video_id || payload?.params?.id || payload?.video_id;
        return state.set('regeneratingVideoId', videoId);
      }
      return state;
    }

    case ModuleEvents.SET_REGENERATING_VIDEO_ID: {
      return state.set('regeneratingVideoId', payload);
    }

    case ModuleEvents.FETCH_SUBTITLE_STATUS: {
      if (payload && !payload.error) {
        const data = _.get(payload, 'data', payload);
        const status = data?.status || payload?.status;
        const statusStr = typeof status === 'string' ? status.toLowerCase() : '';
        const isDone = statusStr === 'completed' || statusStr === 'cancelled';

        let newState = state.set('subtitleStatus', data);
        if (isDone) {
          newState = newState.set('regeneratingVideoId', null);
        }
        return newState;
      }
      return state;
    }

    case ModuleEvents.CHECK_VIDEO_ASSOCIATION: {
      if (payload && !payload.error && payload.status_code && payload.status_code == 1) {
        const data = _.get(payload, 'data', null);
        return state.set('videoAssociation', data);
      }
      return state;
    }

    default:
      return state;
  }
};
